import React, { Component } from 'react';
import { connect } from "react-redux";
import {firstLetterText, messageReplace} from '../../lib/helper'
import {generateRandomAvatarOptions} from '../../lib/generateRandomAvatarOptions'
import TimeAgo from "react-timeago";
import Avatar from 'avataaars';
import {
    Link
} from "react-router-dom";
@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})

class Chatli extends Component {

    constructor(props) {
        super(props);

        this.state={
            "showCloseChat":false,
            "showChatTime":true,
        }
        this.onMouseOver=this.onMouseOver.bind(this);
        this.onMouseOut=this.onMouseOut.bind(this);


    }
    onMouseOver(){

        this.setState({
            "showCloseChat":true,
            "showChatTime":false,
        })
    }

    onMouseOut(){
        this.setState({
            "showCloseChat":false,
            "showChatTime":true
        })
    }






    render() {
        const { t } = this.props;
        var unreadMessage=this.props.data.messages.filter(message=>message.read_agent_state==2 && (message.receiver==2 || message.receiver==3) && message.sender==1).length;
        if(this.props.data.user_status!=1){
            this.props.data.typing = 0;
        }
        return (

            <Link to={"/chat/"+this.props.data.id}>
            <li
                onMouseEnter={this.onMouseOver.bind(this)}
                onMouseLeave={this.onMouseOut.bind(this)}
                className={"user-list-item "+(this.props.data.id==this.props.selected_id ? 'active' : '')}
                style={this.props.data.user_closed!=0 ? {opacity:"0.5"} : {}} >
                        <div>
                            <div className={"avatar  "+(this.props.data.user_status==1 ? 'avatar-online' : 'avatar-offline')}>

                                <div
                                    className={"letter-avatar "}
                                >
                                    <Avatar
                                        style={{ width: 'auto', height: 'auto' }}
                                        avatarStyle='Circle'
                                        {...generateRandomAvatarOptions(this.props.data.random) } />

                                </div>
                            </div>
                        </div>
                        <div className="users-list-body">
                            <div>
                                <h5>{firstLetterText(this.props.data.user_name)} {this.props.data.supervised===1 ? ","+this.props.data.agent_name : "" }</h5>
                                <p className="last_message">
                                    {this.props.data.status=="A" &&
                                        <React.Fragment>
                                        {typeof this.props.data.vote !== "undefined" &&
                                              <React.Fragment>
                                                  {typeof this.props.data.vote.vote !== "undefined" &&
                                                  <React.Fragment>
                                                      {this.props.data.vote.vote == 1 &&
                                                          <span className="chatVoteUp"></span>
                                                      }
                                                      {this.props.data.vote.vote == 2 &&
                                                      <span className="chatVoteDown"></span>
                                                      }

                                                  </React.Fragment>
                                                  }
                                              </React.Fragment>
                                        }


                                        {typeof this.props.data.typing !== "undefined" &&
                                            <>
                                                {this.props.data.typing === 1 &&
                                                    <>
                                                  <span className="animate-typing-col" style={{"marginRight":"5px"}}>
                                                       <span className="dot"></span>
                                                       <span className="dot"></span>
                                                       <span className="dot"></span>
                                                   </span>
                                                        {this.props.data.typingMessage}
                                                    </>
                                                }
                                                {this.props.data.typing === 0 &&
                                                    <span
                                                        dangerouslySetInnerHTML={{__html: messageReplace(this.props.data.last_message)}}
                                                       />

                                                }
                                            </>
                                        }
                                        {typeof this.props.data.typing === "undefined" &&
                                        <span
                                            dangerouslySetInnerHTML={{__html: messageReplace(this.props.data.last_message)}}
                                        />
                                        }


                                        </React.Fragment>
                                        }
                                    {this.props.data.status == "P" &&

                                        <span>Waiting for <TimeAgo date={new Date((this.props.data.status=="A" ? this.props.data.create_chat_time*1000 : this.props.data.pending_time*1000))} /></span>
                                    }

                                   </p>
                            </div>
                            {this.props.data.status == "A" &&
                                <React.Fragment>
                                  <span className="chatLiTimer" style={{display: this.state.showChatTime ? 'block' : 'none'}}><TimeAgo
                                    date={new Date((this.props.data.status == "A" ? this.props.data.create_chat_time * 1000 : this.props.data.pending_time * 1000))}/></span>
                                    <div className="last-chat-time">
                                        {typeof this.props.data.supervised !== "undefined" &&
                                            <React.Fragment>
                                                {this.props.data.supervised === 1 &&
                                                <div className="closeChat" onClick={e=>this.props.closeSupervised(e, this.props.data.id,this.props.data.user_closed)} style={{display: this.state.showCloseChat ? 'block' : 'none'}}>
                                                    <i className='bx bx-x'></i>
                                                </div>
                                                }
                                            </React.Fragment>

                                        }
                                         {(typeof this.props.data.supervised === "undefined" || this.props.data.supervised === 0) &&
                                                 <div className="closeChat" onClick={e=>this.props.closeChat(e, this.props.data.id, this.props.data.user_closed)} style={{display: this.state.showCloseChat ? 'block' : 'none'}}>
                                                     <i className='bx bx-x'></i>
                                                 </div>
                                          }
                                        {unreadMessage > 0 &&
                                        <div className="new-message-count">{unreadMessage}</div>
                                        }
                                    </div>
                                </React.Fragment>
                            }


                        </div>
                    </li>

            </Link>

        )

    }
}

export default Chatli;
